/*
 * AdaButton — the console's route into the assistant.
 *
 * Navigation is in-app (pushState), not a popup and not a link: the console
 * stays a single document, so the browser back button returns here.
 */

import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { ASSISTANT_NAME, VIEW_ASSISTANT, navigateTo } from "../appView";
import { AiIcon } from "./AiIcon";

export default function AdaButton({ selectedNode }) {
  return (
    <>
      <Styles />
      <button
        className="ada-cta"
        onClick={() => navigateTo(VIEW_ASSISTANT, { node: selectedNode, from: "assistant" })}
        title={`Ask ${ASSISTANT_NAME} about this edge`}
      >
        <span className="ada-sheen" aria-hidden="true" />
        <AiIcon size={15} className="ada-mark" aria-hidden="true" />
        <span className="ada-label">Ask&nbsp;{ASSISTANT_NAME}</span>
        <FiArrowRight size={14} className="ada-arrow" />
      </button>
    </>
  );
}

function Styles() {
  return (
    <style>{`
.ada-cta{
  position:relative;overflow:hidden;display:inline-flex;align-items:center;gap:9px;
  padding:9px 17px;border-radius:999px;cursor:pointer;
  font-size:13px;font-weight:600;letter-spacing:.01em;color:#F2F4FB;
  background:linear-gradient(120deg,#0EA5E9 0%,#6366F1 46%,#A855F7 100%);
  border:1px solid rgba(255,255,255,.20);
  box-shadow:0 6px 22px -8px rgba(99,102,241,.85),inset 0 1px 0 rgba(255,255,255,.28);
  transition:transform .18s,box-shadow .18s,filter .18s;
}
.ada-cta:hover{
  transform:translateY(-1px);filter:saturate(1.12);
  box-shadow:0 10px 30px -8px rgba(168,85,247,.95),inset 0 1px 0 rgba(255,255,255,.34);
}
.ada-cta:active{transform:translateY(0)}
.ada-cta:focus-visible{outline:2px solid #A5B4FC;outline-offset:3px}

/* The shine: a narrow highlight that sweeps across on a slow loop. Pauses on
   hover so it never animates under the cursor while someone is reading it. */
.ada-sheen{
  position:absolute;top:0;left:-140%;width:60%;height:100%;
  background:linear-gradient(100deg,transparent,rgba(255,255,255,.42),transparent);
  animation:adasheen 4.2s ease-in-out infinite;
}
.ada-cta:hover .ada-sheen{animation-play-state:paused}
@keyframes adasheen{0%{left:-140%}55%{left:140%}100%{left:140%}}

/* The mark every AI feature wears (AiIcon), breathing slowly. */
.ada-mark{
  position:relative;z-index:1;flex:none;color:#fff;
  filter:drop-shadow(0 0 4px rgba(255,255,255,.75));
  animation:adapulse 2.4s ease-in-out infinite;
}
@keyframes adapulse{0%,100%{opacity:.75;transform:scale(.94)}50%{opacity:1;transform:scale(1)}}

.ada-label{position:relative;z-index:1}
.ada-arrow{position:relative;z-index:1;transition:transform .18s}
.ada-cta:hover .ada-arrow{transform:translateX(3px)}

@media (prefers-reduced-motion:reduce){
  .ada-sheen,.ada-mark{animation:none}
}
`}</style>
  );
}
